export class InventoryModel {
  inventoryId: number = 0;
  code: number = 0;
  typeInventoryId: number = 0;
  name: string = '';
  localCosting: boolean = true;
  swInternalOrder: boolean = false;
  inventoryClassId: number = 0;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
